import React, { Suspense, useEffect } from 'react';

import { Outlet } from 'react-router-dom';

import { useRouterChangeToTop } from '@commonPackage/hooks/useRouterChangeToTop';
import { UrsModal } from '@commonPackage/components/UrsModal';
import { configResponsive, useAntLocale } from '@fuxi/eevee-hooks';
import {
  LOGIN_BASE_URL,
  LoginInfoContextProvider,
  USER_ACCOUNT_URL,
  getCustomUserInfoUrl,
  getHmacHeaders,
  isHeadlessChrome,
} from '@yaotai/common-utils';

import { useReferralCode } from '@portalCommon/hooks/useReferralCode';
import { YAOTAI_RESPONSE_CONFIG } from '@commonPackage/constants';
import { YaotaiGlobalContext } from '@commonPackage/contexts';
import * as Sentry from '@sentry/react';
import { setTrackerConfig } from '@yaotai/yaotai-tracker';
import { getTrackEnv, getYaotaiRbacCookieDomain } from '@commonPackage/utils';
import { PORTAL_NO_AUTH_URL } from '@portalCommon/constants';
import { getPortalPcUrsOptions } from '@/utils';
import { GlobalStateContainer, useGlobalState } from './index.container';

configResponsive(YAOTAI_RESPONSE_CONFIG);

export function MainRouter() {
  const { writeCodeToSessionStorage } = useReferralCode();
  writeCodeToSessionStorage();

  useRouterChangeToTop();
  useEffect(() => {
    if (document.getElementById('pre-info')) {
      (document.getElementById('pre-info') as HTMLDivElement).style.display = 'none';
    }
  }, []);
  const { ursModalRef } = useGlobalState();
  const { language } = useAntLocale();

  // useEffect(() => {
  //   updateCanonicalUrl(window.location.href);
  // }, [window.location.pathname]);

  return (
    <LoginInfoContextProvider
      isUrs4login={false}
      cookieDomain={getYaotaiRbacCookieDomain()}
      customUserInfoUrl={getCustomUserInfoUrl({ gateWayUrl: import.meta.env.VITE_GATEWAY_BASE_URL })}
      customNoAuthRedirectUrl={PORTAL_NO_AUTH_URL}
      getCustomUserInfoHeaders={() =>
        getHmacHeaders({
          url: USER_ACCOUNT_URL,
          baseURL: `${
            import.meta.env.VITE_GATEWAY_BASE_URL ? import.meta.env.VITE_GATEWAY_BASE_URL : ''
          }${LOGIN_BASE_URL}`,
          secret: import.meta.env.VITE_YEYING_SECRET_KEY!,
          username: import.meta.env.VITE_YEYING_SECRET_USERNAME!,
          apiKey: import.meta.env.VITE_YEYING_API_KEY!,
        })
      }
      afterGettingHook={data => {
        Sentry.setUser(data);
        setTrackerConfig({
          uid: data?.uid,
          username: data?.name,
          env: getTrackEnv(import.meta.env.VITE_APP_MODE ?? '') as any,
        });
      }}>
      <YaotaiGlobalContext.Provider
        initialState={{
          isMainVersion: import.meta.env.VITE_MAIN === 'true',
          monorepoType: 'portal',
          mediaType: 'pc',
        }}>
        <Suspense>
          <Outlet />
        </Suspense>
        {/* <Routes>
            <Route path="/:lang/*" element={<LanguageLayout />} />
            {routerConfig.map(({ index, path, element }) => {
              return <Route key={index ? '/' : `/${path}`} path={index ? '/' : `/${path}`} element={element} />;
            })}
          </Routes>
           */}

        {!isHeadlessChrome && (
          <UrsModal
            options={getPortalPcUrsOptions({
              cssFiles: `/custom-login-${String(language).includes('en') ? 'en' : 'zh'}.css`,
            })}
            cookieDomain={getYaotaiRbacCookieDomain()!}
            rbacServer={import.meta.env.VITE_RBAC_SERVER!}
            rbacUrl={import.meta.env.VITE_RBAC!}
            overseaRbacUrl={import.meta.env.VITE_OVERSEA_RBAC!}
            ref={ursModalRef}
          />
        )}
      </YaotaiGlobalContext.Provider>
    </LoginInfoContextProvider>
  );
}

export function MainRouterWrapper() {
  return (
    <GlobalStateContainer.Provider>
      <MainRouter />
    </GlobalStateContainer.Provider>
  );
}
